import { logger } from "@tecma/logs-fe";
import {
  Survey,
  SurveyQuestionResponse,
  SurveyResponses,
} from "modules/survey/domain/survey/survey.types";

export const getSurveysByProject = async (
  project_id: string,
  baseUri: string,
) => {
  try {
    const response = await fetch(
      `${baseUri}/survey/v2/surveys/project/${project_id}`,
    );
    if (!response.ok) {
      throw new Error("error fetching surveys");
    }
    const parsedResponse = await response.json();
    return parsedResponse.data as Array<Survey>;
  } catch (err) {
    logger.error(err);
    throw Error();
  }
};

export const getSurveyById = async ({
  survey_id,
  order,
  question_id,
  baseUri,
}: {
  survey_id: string;
  baseUri: string;
  order?: number;
  question_id?: string;
}) => {
  try {
    const composeQueryParams = new URLSearchParams();
    if (order) composeQueryParams.append("order", order.toString());
    if (question_id) composeQueryParams.append("question_id", question_id);

    const response = await fetch(
      `${baseUri}/survey/v1/surveys/${survey_id}/question?${composeQueryParams.toString()}`,
    );
    if (!response.ok) {
      throw new Error("error fetching survey");
    }
    const parsedResponse = await response.json();
    return parsedResponse as SurveyQuestionResponse;
  } catch (err) {
    logger.error(err);
    throw Error();
  }
};

interface PatchSurveyResponsesParams {
  client_id: string;
  survey_id: string;
  surveyResponses: SurveyResponses;
  project_Id: string;
  token: string;
  baseUri: string;
}

export const patchSurveyResponses = async ({
  client_id,
  survey_id,
  surveyResponses,
  project_Id,
  token,
  baseUri,
}: PatchSurveyResponsesParams) => {
  try {
    const response = await fetch(
      `${baseUri}/client/v2/clients/${client_id}/surveys/${survey_id}/project/${project_Id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        method: "PATCH",
        body: JSON.stringify(surveyResponses),
        referrerPolicy: "unsafe-url",
      },
    );
    if (!response.ok) {
      throw new Error("error patching survey responses");
    }
    const parsedResponse = await response.json();
    return parsedResponse;
  } catch (err) {
    logger.error(err);
    throw Error();
  }
};

interface PatchBulkSurveysResponsesParams
  extends Omit<PatchSurveyResponsesParams, "surveyResponses"> {
  surveysResponses: Survey[];
}

export const patchBulkSurveysResponses = async ({
  client_id,
  survey_id,
  surveysResponses,
  project_Id,
  token,
  baseUri,
}: PatchBulkSurveysResponsesParams) => {
  try {
    const response = await fetch(
      `${baseUri}/client/v2/clients/${client_id}/surveys/${survey_id}/project/${project_Id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        method: "PATCH",
        body: JSON.stringify({ surveys: surveysResponses }),
        referrerPolicy: "unsafe-url",
      },
    );
    if (!response.ok) {
      throw new Error("error patching survey responses");
    }
    const parsedResponse = await response.json();
    return parsedResponse;
  } catch (err) {
    logger.error(err);
    throw Error();
  }
};
